import React, {useEffect, useState} from 'react';

export function useSetTimeout() {
  const [timerId, setTimerId] = useState<number | null>(null);

  // clear the timeout on unmount
  useEffect(() => {
    return () => {
      if (timerId != null) {
        window.clearTimeout(timerId);
      }
    };
  }, [timerId]);

  return (func: () => unknown, delay: number) => {
    const id = window.setTimeout(func, delay);
    setTimerId(id);
  };
}

interface ModalProps<T> {
  Modal: React.ComponentType<{item: T; onClose: () => unknown; show: boolean}>;
}

export function useModal<T>({Modal}: ModalProps<T>) {
  // Handles display/hide of Modal component.
  const [isVisible, setIsVisible] = useState(false);
  const [item, setItem] = useState<T | null>(null);

  function show(item: T) {
    setItem(item);
    setIsVisible(true);
  }

  function onClose() {
    setIsVisible(false);
    setItem(null);
  }

  return {
    show,
    Modal:
      item != null
        ? React.createElement(Modal, {item, onClose, show: isVisible})
        : null,
  };
}
